import { createElement, HTMLAttributes } from 'react';

type Props = HTMLAttributes<HTMLElement> & {
  as?: string;
};

export default function InnerHTML({ as = 'div', children, ...rest }: Props) {
  return !!children ? createElement(as, { ...rest, dangerouslySetInnerHTML: { __html: children } }) : null;
}
